import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { ServiceConfig } from './service-config';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class SeedingService {
  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/seeding/';
  private data: any;



  constructor(private http: HttpClient) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
  }

  public getVideos(body) {
    let url = this.baseUrl + 'youtube/search?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  //viettung tra loi binh luan
  public comment(body) {
    let url = this.baseUrl + 'comment/reply?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public replyComment(body) {
    let url = this.baseUrl + 'comment/replyComment?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public editComment(body) {
    let url = this.baseUrl + 'comment/update?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public deleteComment(body) {
    let url = this.baseUrl + 'comment/delete?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  //end viettung

  // api kiểm tra tài khoản tương tác hợp lệ
  public checkAccount(body) {
    let url = this.baseUrl + '/checkAccount?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  // api share post

  public sharePost(body) {
    let url = this.baseUrl + '/post/share?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  //Kiểm tra tính khả dụng tài khoản tương tác: tương tác với bình luận   
  public checkCommentAvailable(body) {
    let url = this.baseUrl + '/checkCommentAvailable?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  // xóa tài khoản tương tác
  public removeUser(body) {
    let url = this.baseUrl + '/removeUser?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }


  public likeComment(body) {
    let url = this.baseUrl + '/like?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public likePost(body) {
    let url = this.baseUrl + '/likePost?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public dislikeComment(body) {
    let url = this.baseUrl + '/dislike?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public dislikePost(body) {
    let url = this.baseUrl + '/dislikePost?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/seeding.service.ts